import * as React from 'react'
import type { SVGIllustrationProps } from '../BaseIllustration'
import { BaseIllustration } from '../BaseIllustration'

export const MobilePhoneIllustration = (props: SVGIllustrationProps) => (
  <BaseIllustration xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 240 160" {...props}>
    <path
      fill="url(#dhl__illustrations_mobilephoneillustration_svg_a)"
      d="m71.621 146.557 37.364-7.426-10.887-5.358-37.475 7.427z"
      opacity={0.5}
    />
    <path
      fill="#3A3A3A"
      d="m102.949 136.433 53.324-9.607c2.703-.48 4.851-3.103 4.851-5.801l2.851-102.904c-1.37-4.101-5.813-6.466-12.035-5.173l-48.361 8.72c-3.111.554-5.666 3.621-5.666 6.799l.148 104.715s-.148 4.692 3.073 5.949c1.148.443 2.926.665 4.296.554"
    />
    <path
      fill="#000"
      d="m159.495 130.041-53.324 9.607c-2.704.48-4.888-1.33-4.888-4.064l-.148-104.752c0-2.735 2.184-5.32 4.851-5.801l53.323-9.607c2.704-.48 4.889 1.33 4.889 4.064l.148 104.752c0 2.697-2.185 5.321-4.851 5.801"
    />
    <path fill="#fff" d="m160.198 117.663-54.805 9.903-.111-90.194 54.805-9.866z" />
    <path fill="#E5E5E5" d="m160.198 117.663-54.694 9.865-.037-9.606 54.731-9.903z" />
    <path
      fill="#C9C9C9"
      d="M124.304 59.932c1.826-2.174 1.82-5.18-.014-6.713s-4.801-1.015-6.627 1.159-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M136.556 57.717c1.826-2.174 1.82-5.18-.014-6.713s-4.801-1.015-6.627 1.159-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M148.79 55.528c1.827-2.174 1.82-5.18-.014-6.713-1.833-1.534-4.8-1.015-6.627 1.159s-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M124.317 71.788c1.826-2.174 1.82-5.18-.014-6.714s-4.801-1.015-6.627 1.16c-1.826 2.173-1.82 5.179.014 6.713 1.833 1.533 4.801 1.014 6.627-1.16M136.569 69.573c1.826-2.174 1.82-5.18-.014-6.714s-4.801-1.015-6.627 1.16c-1.826 2.173-1.82 5.179.014 6.713s4.801 1.015 6.627-1.16M148.775 67.36c1.826-2.174 1.82-5.18-.014-6.714-1.834-1.533-4.801-1.014-6.627 1.16s-1.82 5.18.014 6.713c1.833 1.534 4.801 1.015 6.627-1.16M124.301 83.62c1.826-2.175 1.82-5.18-.014-6.714s-4.801-1.015-6.627 1.159-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M136.582 81.428c1.826-2.174 1.82-5.18-.014-6.714s-4.801-1.015-6.627 1.16c-1.826 2.173-1.82 5.179.014 6.713s4.801 1.015 6.627-1.16M148.787 79.215c1.827-2.174 1.82-5.18-.013-6.713-1.834-1.534-4.801-1.015-6.628 1.159s-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M124.314 95.474c1.826-2.174 1.82-5.18-.014-6.713s-4.801-1.015-6.627 1.159-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M136.566 93.26c1.826-2.175 1.82-5.18-.014-6.714s-4.801-1.015-6.627 1.159-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159M148.8 91.07c1.826-2.174 1.82-5.18-.014-6.713s-4.801-1.015-6.627 1.159-1.82 5.18.014 6.713 4.801 1.015 6.627-1.159"
    />
    <path
      fill="#FDCF0C"
      d="M136.579 105.114c1.826-2.174 1.82-5.18-.014-6.713s-4.801-1.015-6.627 1.159-1.82 5.179.014 6.713 4.801 1.015 6.627-1.159"
    />
    <defs>
      <linearGradient
        id="dhl__illustrations_mobilephoneillustration_svg_a"
        x1={79.405}
        x2={90.172}
        y1={150.731}
        y2={129.552}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.269} stopColor="#1D1D1B" stopOpacity={0} />
        <stop offset={0.511} stopColor="#181816" stopOpacity={0.364} />
        <stop offset={0.817} stopColor="#080807" stopOpacity={0.825} />
        <stop offset={0.933} />
      </linearGradient>
    </defs>
  </BaseIllustration>
)
